import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'Billing.CancelDialog.Title',
    defaultMessage: 'Cancel subscription',
  },
  description: {
    id: 'Billing.CancelDialog.Description',
    defaultMessage:
      'Your subscription will remain active until the end of the current billing period. You can resume anytime before then.',
  },
  endDate: {
    id: 'Billing.CancelDialog.EndDate',
    defaultMessage: 'Your service will end on {date}.',
  },
  confirm: {
    id: 'Billing.CancelDialog.Confirm',
    defaultMessage: 'Cancel at period end',
  },
  keep: {
    id: 'Billing.CancelDialog.Keep',
    defaultMessage: 'Keep subscription',
  },
});

function CancelSubscriptionDialog({ open, onClose, onConfirm, endDate }) {
  const { formatMessage } = useIntl();
  const [loading, setLoading] = React.useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{formatMessage(messages.title)}</DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: endDate ? 2 : 0 }}>
          {formatMessage(messages.description)}
        </Typography>
        {endDate && (
          <Typography variant="body2" color="text.secondary">
            {formatMessage(messages.endDate, { date: endDate })}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {formatMessage(messages.keep)}
        </Button>
        <Button color="error" variant="contained" onClick={handleConfirm} disabled={loading}>
          {formatMessage(messages.confirm)}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

CancelSubscriptionDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  endDate: PropTypes.string,
};

CancelSubscriptionDialog.defaultProps = {
  endDate: null,
};

export default CancelSubscriptionDialog;
